import Box from 'fe-design-base/atoms/Box';
import Text from 'fe-design-base/atoms/Text';
import BackLink from 'fe-design-base/organisms/BackLink';

interface WebViewAltProps {
  showBackButton?: boolean;
}

const WebViewAlt = ({ showBackButton }: WebViewAltProps) => (
  <Box w="80%" h="100%" hcenter vcenter column m={48}>
    <Box w={240} hcenter column gap={16}>
      <Text i18n="manage_plans.web_view_alt.message" />
      {showBackButton && <BackLink fallbackLinkTo="/team" />}
    </Box>
  </Box>
);

export default WebViewAlt;
